module.exports = __webpack_public_path__ + "static/media/Large.71f9ed52.png";